import { memo, useCallback } from 'react';
import PropTypes from 'prop-types';
import { makeStyles, IconButton } from '@material-ui/core';
import RemoveIcon from '@material-ui/icons/Close';
import { getAllIndexes } from '../../../../../../../helpers';
import { useDispatch, useSelector } from 'react-redux';
import { setAccountBackendErrors } from '../../../../../../../../../redux_store';

const useStyles = makeStyles(() => ({
  tableItem: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
}));

const CptEndCheckbox = ({
                          form,
                          setCpts,
                          index,
                        }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { backendErrors } = useSelector((state) => state.accountEditing);
  const setBackendErrors = (newErrors) => {
    dispatch(setAccountBackendErrors(newErrors));
  };

  const updateErrors = useCallback(async (index) => {
    if (backendErrors) {
      if (backendErrors[`ispConfiguration.services[${index}]`]) {
        const newBackendErrors = { ...backendErrors };
        delete newBackendErrors[`ispConfiguration.services[${index}]`];
        setBackendErrors(newBackendErrors);
      } else if (backendErrors?.ispConfiguration?.services && backendErrors?.ispConfiguration?.services[index]) {
        const newErrors = {
          ...backendErrors,
          ispConfiguration: {
            ...backendErrors.ispConfiguration,
            services: backendErrors.ispConfiguration.services.filter((service, i) => {
              return i !== index;
            }),
          },
        };

        if (!newErrors.ispConfiguration.services.length) {
          delete newErrors.ispConfiguration.services
        }
        setBackendErrors(newErrors);
      }
    }
  }, [backendErrors, setBackendErrors]);

  const updateCpts = useCallback((index) => {
    setCpts(prevCpts => {
      const newCpts = prevCpts.length > 1
        ? [...prevCpts.slice(0, index), ...prevCpts.slice(index + 1)]
        : [];

      return newCpts.map((item, i) => ({
        ...item,
        index: i,
      }));
    });
  }, [setCpts]);

  const onDismiss = useCallback(async (index, form) => {
    const services = form.values?.ispConfiguration?.services;
    if (!services) return;
    const newCpt = [...services.slice(0, index), ...services.slice(index + 1)];
    await form.setFieldValue('ispConfiguration.services', newCpt);
    updateCpts(index);
    await updateErrors(index);
  }, [backendErrors, updateCpts, updateErrors]);

  return (
    <div className={classes.tableItem}>
      <IconButton
        aria-label="delete"
        size="small"
        onClick={() => onDismiss(index, form)}
      >
        <RemoveIcon fontSize="small" />
      </IconButton>
    </div>
  );
};

CptEndCheckbox.propTypes = {
  form: PropTypes.object.isRequired,
  backendErrors: PropTypes.object,
  cpts: PropTypes.array.isRequired,
  setCpts: PropTypes.func.isRequired,
  setBackendErrors: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
};

export default memo(CptEndCheckbox);
